"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** Класс, представляющий секцию с возможностью сворачивания и разворачивания. */
class CollapsibleSection {
    /**
     * Конструктор класса CollapsibleSection.
     *
     * @param $section - Элемент секции.
     * @param options - Опции конфигурации.
     * @param options.maxHeight - Максимальная высота для свёрнутой секции.
     */
    constructor($section, options = {}) {
        this.$section = $section;
        this.options = options;
        const dataMaxHeight = $section.getAttribute('data-max-height');
        this.$content = $section.querySelector('.collapsible-section__content');
        this.$button = $section.querySelector('.collapsible-section__toggle-button');
        this.styleWatchMaxHeight = dataMaxHeight === 'auto';
        this.maxHeight = this.styleWatchMaxHeight ? -1 : options.maxHeight || parseInt(dataMaxHeight || '150', 10);
        this.isExpanded = $section.classList.contains('collapsible-section--expanded');
        this.tabIndexMap = new Map();
        this.initialText = '';
        this.initialization();
    }
    /** Инициализирует секцию, устанавливая стили и обработчики событий. */
    initialization() {
        this.updateSectionHeight();
        this.focusableElements = this.$content.querySelectorAll('a[href], area[href], input:not([disabled]):not([type="hidden"]):not([aria-hidden]), select:not([disabled]):not([aria-hidden]), textarea:not([disabled]):not([aria-hidden]), button:not([disabled]):not([aria-hidden]), iframe, object, embed, [contenteditable], [tabindex]:not([tabindex^="-"])');
        if (this.$content.scrollHeight > this.maxHeight) {
            this.$button.style.display = '';
            this.updateFocusableElements();
            this.$button.addEventListener('click', () => this.toggle());
            this.$section.addEventListener('transitionend', e => {
                if (e.propertyName === 'min-height') {
                    if (this.isExpanded) {
                        /* Открылось */
                        this.$section.style.maxHeight = 'unset';
                        this.$section.style.minHeight = '';
                    }
                    else {
                        /* Закролось */
                        this.$section.style.minHeight = '';
                    }
                }
            });
        }
        else {
            this.$button.style.display = 'none';
        }
    }
    /** Обновляет минимальную высоту секции в зависимости от текущего состояния. */
    updateSectionHeight() {
        console.log(this.getCalculatedMaxHeight());
        this.$section.style.minHeight = this.isExpanded
            ? `${this.$section.offsetHeight + (this.$content.scrollHeight - this.$content.offsetHeight)}px`
            : `${this.getCalculatedMaxHeight()}px`;
    }
    /** Обновляет фокусируемые элементы внутри секции для обеспечения доступности. */
    updateFocusableElements() {
        const contentRect = this.$content.getBoundingClientRect();
        this.focusableElements.forEach(element => {
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top >= contentRect.top &&
                rect.bottom <= contentRect.top + (this.isExpanded ? this.$content.scrollHeight : this.getCalculatedMaxHeight());
            if (isVisible) {
                element.tabIndex = this.tabIndexMap.get(element) || 0;
                element.removeAttribute('aria-hidden');
            }
            else {
                this.tabIndexMap.set(element, element.tabIndex);
                element.tabIndex = -1;
                element.setAttribute('aria-hidden', 'true');
            }
        });
    }
    /** Получает максимальную высоту из стиля секции. */
    getMaxHeightFromStyle() {
        return +getComputedStyle(this.$section, '::before').maxHeight.replace('px', '');
    }
    /** Возвращает вычисленное значение maxHeight. */
    getCalculatedMaxHeight() {
        return this.styleWatchMaxHeight ? this.getMaxHeightFromStyle() : this.maxHeight;
    }
    /** Переключает состояние секции между развёрнутым и свёрнутым. */
    toggle() {
        this.isExpanded ? this.close() : this.open();
    }
    /** Разворачивает секцию. */
    open() {
        var _a;
        this.updateSectionHeight();
        this.isExpanded = true;
        if (!this.initialText)
            this.initialText = ((_a = this.$button.querySelector('span')) === null || _a === void 0 ? void 0 : _a.textContent) || '';
        this.$button.querySelector('span').textContent = 'Свернуть';
        this.$button.setAttribute('aria-expanded', 'true');
        this.$section.classList.add('collapsible-section--expanded');
        this.updateSectionHeight();
        this.updateFocusableElements();
        this.emitEvent('opened');
    }
    /** Сворачивает секцию. */
    close() {
        this.updateSectionHeight();
        this.isExpanded = false;
        this.$section.style.maxHeight = '';
        this.$button.querySelector('span').textContent = this.initialText || 'Развернуть';
        this.$button.setAttribute('aria-expanded', 'false');
        const handlerRemoveExpanded = (e) => {
            if (e.target.classList.contains('collapsible-section')) {
                this.$section.classList.remove('collapsible-section--expanded');
                this.$section.removeEventListener('transitionend', handlerRemoveExpanded);
            }
        };
        this.$section.addEventListener('transitionend', handlerRemoveExpanded);
        this.updateSectionHeight();
        this.updateFocusableElements();
        this.emitEvent('closed');
    }
    /**
     * Генерирует пользовательское событие для секции.
     *
     * @param eventName - Имя события.
     */
    emitEvent(eventName) {
        const event = new Event(eventName, { bubbles: false });
        this.$section.dispatchEvent(event);
    }
}
exports.default = CollapsibleSection;
